// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-logo {
  width: auto;
  height: auto;
  position: relative;
  left: 126px;
  top: 11px;
}

.total-bg {
  position: fixed;
  top: 0px;
  bottom: 0px;
  height: 100%;
  width: 100%;
  background-repeat: round;
  background-color: #ccc;
}

.pt-10 {
  padding-top: 10em;
}

.login-card {
  margin: auto;
  width: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
}

.left-half {
  background: #fff;
  padding: 15px;
}

.right-half {
  background: rgb(41, 110, 212);
  padding: 15px;
}

.box {
  box-shadow: 2px 2px 4px 1px #676767;
}

.bg-white {
  background: #fff;
}

.login-title {
  font-size: 21px;
  color: #fff;
  line-height: 27px;
  font-family: "Roboto", sans-serif;
}
.login-title span {
  display: block;
  font-weight: 500;
}

.btn-dark-green:hover {
  background-color: #3fa044 !important;
}

.org-login-logo {
  max-height: 100px;
  height: auto;
  width: auto;
  max-width: 200px;
}

/* Large Devices, Wide Screens */
@media (min-width: 1200px) {
  .loginfields {
    padding: 0 24px !important;
  }
}
.btn {
  padding: 0.5rem 2.14rem !important;
  text-transform: capitalize !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AACJ;;AACA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,UAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAGJ;;AADA;EACI,gBAAA;EACA,aAAA;AAIJ;;AAFA;EACI,6BAAA;EACA,aAAA;AAKJ;;AAHA;EACI,mCAAA;AAMJ;;AAJA;EACI,gBAAA;AAOJ;;AALA;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,iCAAA;AAQJ;AAPI;EACI,cAAA;EACA,gBAAA;AASR;;AANA;EACI,oCAAA;AASJ;;AAPA;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAUJ;;AAPA,gCAAA;AACA;EACC;IACO,0BAAA;EAUN;AACF;AAPA;EACI,kCAAA;EACA,qCAAA;AASJ","sourcesContent":[".login-logo{\r\n    width: auto;\r\n    height: auto;\r\n    position: relative;\r\n    left: 126px;\r\n    top: 11px;\r\n}\r\n.total-bg{\r\n    position: fixed;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    height: 100%;\r\n    width: 100%;\r\n    background-repeat: round;\r\n    background-color: #ccc;\r\n    // background-image: url('../../../assets/images/bg.png');\r\n}\r\n.pt-10{\r\n    padding-top: 10em;\r\n}\r\n.login-card{\r\n    margin: auto;\r\n    width: 50%;\r\n    transform: translate(-50%, -50%);\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n}\r\n.left-half{\r\n    background: #fff;\r\n    padding: 15px;\r\n}\r\n.right-half{\r\n    background: rgb(41,110,212);\r\n    padding: 15px;\r\n}\r\n.box{\r\n    box-shadow: 2px 2px 4px 1px #676767;\r\n}\r\n.bg-white{\r\n    background: #fff;\r\n}\r\n.login-title {\r\n    font-size: 21px;\r\n    color: #fff;\r\n    line-height: 27px;\r\n    font-family: \"Roboto\", sans-serif;\r\n    span {\r\n        display: block;\r\n        font-weight: 500;\r\n    }\r\n}\r\n.btn-dark-green:hover {\r\n    background-color: #3fa044 !important;\r\n}\r\n.org-login-logo {\r\n    max-height: 100px;\r\n    height: auto;\r\n    width: auto;\r\n    max-width: 200px;\r\n}\r\n\r\n/* Large Devices, Wide Screens */\r\n@media (min-width: 1200px) {\r\n\t.loginfields{\r\n        padding: 0 24px !important;\r\n    }\r\n}\r\n\r\n.btn{\r\n    padding: 0.50rem 2.14rem !important;\r\n    text-transform:capitalize !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
